import GetSchedulerByClassesRequestModelBase from '../_generated/modelBases/get-scheduler-by-classes-request-model-base';

export default class GetSchedulerByClassesRequestModel extends GetSchedulerByClassesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
